import { useApi } from '../composables/useApi'
import { URLS } from '../constants/urls'

export function reuniaoService() {
	const api = useApi()

	async function fetchMeetingData(query) {
		return api.query(
			`${window.origin}${URLS.atendimento_reuniao_sai}${query}`,
			{ forceCache: true }
		)
	}

	async function getAtendimentoReuniaoSai(query) {
		return api.query(`${window.origin}${URLS.atendimento_reuniao_sai}`, query, {
			forceCache: true,
		})
	}
	return {
		fetchMeetingData,
		getAtendimentoReuniaoSai,
	}
}
